// Lightweight frontend logger.
//
// Gates verbose `debug` output so production builds stay quiet, while always
// surfacing `warn`/`error`. Enabled in non-production, or when
// REACT_APP_DEBUG === 'true'. See docs/LOGGING.md for the convention.
//
// Usage:
//   import { logger } from '../utils/logger';
//   logger.debug('Parsed trip', data);   // dev-only
//   logger.warn('Falling back', err);     // always
//   logger.error('Request failed', err);  // always
//
// Never log secrets, tokens, or PII (phone numbers, full addresses). Reference
// values by id where possible.

const debugEnabled =
  process.env.NODE_ENV !== 'production' ||
  process.env.REACT_APP_DEBUG === 'true';

export const logger = {
  /** Verbose diagnostics — suppressed in production unless REACT_APP_DEBUG=true. */
  debug: (...args) => {
    if (debugEnabled) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  },
  /** Recoverable issues / fallbacks — always emitted. */
  warn: (...args) => {
    // eslint-disable-next-line no-console
    console.warn(...args);
  },
  /** Unexpected failures — always emitted. */
  error: (...args) => {
    // eslint-disable-next-line no-console
    console.error(...args);
  },
};

export default logger;
